// Navigation par ancre (#/entrees/cam1) : aucune configuration côté serveur, fonctionne derrière Nginx.
import { useEffect, useState } from "react";

export type Route =
  | { page: "dashboard" }
  | { page: "inputs" }
  | { page: "input"; id: string }
  | { page: "outputs" }
  | { page: "matrix" }
  | { page: "journal" }
  | { page: "users" }
  | { page: "settings" }
  | { page: "requests" }
  // pages publiques, sans connexion (liens des e-mails d'inscription)
  | { page: "signup" }
  | { page: "signup-confirm"; token: string }
  | { page: "invitation"; token: string }
  | { page: "access"; token: string };

export const PUBLIC_PAGES: Route["page"][] = ["signup", "signup-confirm", "invitation", "access"];

export function parseRoute(hash: string): Route {
  const [first, second, third] = hash.replace(/^#\/?/, "").split("/").filter(Boolean).map(decodeURIComponent);
  switch (first) {
    case "entrees":
      return second ? { page: "input", id: second } : { page: "inputs" };
    case "sorties":
      return { page: "outputs" };
    case "matrice":
      return { page: "matrix" };
    case "journal":
      return { page: "journal" };
    case "comptes":
      return { page: "users" };
    case "reglages":
      return { page: "settings" };
    case "demandes":
      return { page: "requests" };
    case "inscription":
      return second === "confirmer" && third ? { page: "signup-confirm", token: third } : { page: "signup" };
    case "invitation":
      return second ? { page: "invitation", token: second } : { page: "dashboard" };
    case "acces":
      return second ? { page: "access", token: second } : { page: "dashboard" };
    default:
      return { page: "dashboard" };
  }
}

export function href(route: Route): string {
  switch (route.page) {
    case "dashboard": return "#/";
    case "inputs": return "#/entrees";
    case "input": return `#/entrees/${encodeURIComponent(route.id)}`;
    case "outputs": return "#/sorties";
    case "matrix": return "#/matrice";
    case "journal": return "#/journal";
    case "users": return "#/comptes";
    case "settings": return "#/reglages";
    case "requests": return "#/demandes";
    case "signup": return "#/inscription";
    case "signup-confirm": return `#/inscription/confirmer/${encodeURIComponent(route.token)}`;
    case "invitation": return `#/invitation/${encodeURIComponent(route.token)}`;
    case "access": return `#/acces/${encodeURIComponent(route.token)}`;
  }
}

export function navigate(route: Route): void {
  window.location.hash = href(route);
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const onChange = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}
